import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableCompagnonCreatePage } from '../../Pages/RH/Compagnons/CompagnonCreate/LoadableCompagnonCreatePage';
import { LoadableCompagnonDetailsPage } from '../../Pages/RH/Compagnons/CompagnonDetails/LoadableCompagnonDetailsPage';
import { LoadableListCompagnonPage } from '../../Pages/RH/Compagnons/ListCompagnon/LoadableListCompagnonPage';

const getListCompagnonRoute = (props: object): AppRouteType => ({
    id: AppRoutes.COMPAGNON_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.COMPAGNON_LIST,
        component: LoadableListCompagnonPage,
        ...props,
    },
});

const getCreateCompagnonRoute = (props: object): AppRouteType => ({
    id: AppRoutes.COMPAGNON_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.COMPAGNON_CREATE,
        component: LoadableCompagnonCreatePage,
        ...props,
    },
});

const getDetailsCompagnonRoute = (props: object): AppRouteType => ({
    id: AppRoutes.COMPAGNON_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.COMPAGNON_DETAILS,
        component: LoadableCompagnonDetailsPage,
        ...props,
    },
});

export const getCompagnonRoutes = (args: object) => [
    getListCompagnonRoute(args),
    getCreateCompagnonRoute(args),
    getDetailsCompagnonRoute(args),
];
